var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 560,
    viewBox: "0 0 564 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 564,
    height: 560,
    rx: 32,
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_791_28467)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 120,
    width: 320,
    height: 320,
    rx: 32,
    fill: "#26272B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.893 193.845C278.372 190.052 285.628 190.052 291.107 193.845L353.107 236.768C357.424 239.757 360 244.673 360 249.923V309.157C360 314.407 357.424 319.323 353.107 322.312L291.107 365.235C285.628 369.028 278.372 369.028 272.893 365.235L210.893 322.312C206.576 319.323 204 314.407 204 309.157V249.923C204 244.673 206.576 239.757 210.893 236.768L272.893 193.845Z",
    fill: "#24252A"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter1_i_791_28467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_791_28467",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.893 34.8449C178.372 31.0517 185.628 31.0517 191.107 34.8449L253.107 77.768C257.424 80.7565 260 85.6728 260 90.9231V150.157C260 155.407 257.424 160.323 253.107 163.312L191.107 206.235C185.628 210.028 178.372 210.028 172.893 206.235L110.893 163.312C106.576 160.323 104 155.407 104 150.157V90.9231C104 85.6728 106.576 80.7565 110.893 77.768L172.893 34.8449Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.893 77.768L110.323 76.9458L110.893 77.768ZM110.893 163.312L111.462 162.489L110.893 163.312ZM191.107 206.235L190.538 205.413L191.107 206.235ZM172.893 206.235L173.462 205.413L172.893 206.235ZM253.107 163.312L253.677 164.134L253.107 163.312ZM191.107 34.8449L190.538 35.6671L191.107 34.8449ZM253.107 77.768L253.677 76.9458L253.107 77.768ZM253.677 76.9458L191.677 34.0227L190.538 35.6671L252.538 78.5902L253.677 76.9458ZM261 150.157V90.9231H259V150.157H261ZM191.677 207.057L253.677 164.134L252.538 162.489L190.538 205.413L191.677 207.057ZM110.323 164.134L172.323 207.057L173.462 205.413L111.462 162.489L110.323 164.134ZM103 90.9231V150.157H105V90.9231H103ZM172.323 34.0227L110.323 76.9458L111.462 78.5902L173.462 35.6671L172.323 34.0227ZM105 90.9231C105 86.0009 107.415 81.392 111.462 78.5902L110.323 76.9458C105.737 80.1211 103 85.3446 103 90.9231H105ZM111.462 162.489C107.415 159.688 105 155.079 105 150.157H103C103 155.735 105.737 160.959 110.323 164.134L111.462 162.489ZM190.538 205.413C185.401 208.969 178.599 208.969 173.462 205.413L172.323 207.057C178.145 211.087 185.855 211.087 191.677 207.057L190.538 205.413ZM259 150.157C259 155.079 256.585 159.688 252.538 162.489L253.677 164.134C258.263 160.959 261 155.735 261 150.157H259ZM191.677 34.0227C185.855 29.9924 178.145 29.9924 172.323 34.0227L173.462 35.6671C178.599 32.111 185.401 32.111 190.538 35.6671L191.677 34.0227ZM252.538 78.5902C256.585 81.3919 259 86.0009 259 90.9231H261C261 85.3446 258.263 80.1211 253.677 76.9458L252.538 78.5902Z",
    fill: "#2E2F33",
    mask: "url(#path-4-inside-1_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter2_i_791_28467)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.893 34.8449C376.372 31.0517 383.628 31.0517 389.107 34.8449L451.107 77.768C455.424 80.7565 458 85.6728 458 90.9231V150.157C458 155.407 455.424 160.323 451.107 163.312L389.107 206.235C383.628 210.028 376.372 210.028 370.893 206.235L308.893 163.312C304.576 160.323 302 155.407 302 150.157V90.9231C302 85.6728 304.576 80.7565 308.893 77.768L370.893 34.8449Z",
    fill: "url(#paint0_linear_791_28467)",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter3_i_791_28467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_791_28467",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.107 353.845C383.628 350.052 376.372 350.052 370.893 353.845L308.893 396.768C304.576 399.757 302 404.673 302 409.923V469.157C302 474.407 304.576 479.323 308.893 482.312L370.893 525.235C376.372 529.028 383.628 529.028 389.107 525.235L451.107 482.312C455.424 479.323 458 474.407 458 469.157V409.923C458 404.673 455.424 399.757 451.107 396.768L389.107 353.845Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M451.107 396.768L451.677 395.946L451.107 396.768ZM451.107 482.312L450.538 481.489L451.107 482.312ZM370.893 525.235L371.462 524.413L370.893 525.235ZM389.107 525.235L388.538 524.413L389.107 525.235ZM308.893 482.312L308.323 483.134L308.893 482.312ZM370.893 353.845L371.462 354.667L370.893 353.845ZM308.893 396.768L308.323 395.946L308.893 396.768ZM308.323 395.946L370.323 353.023L371.462 354.667L309.462 397.59L308.323 395.946ZM301 469.157V409.923H303V469.157H301ZM370.323 526.057L308.323 483.134L309.462 481.489L371.462 524.413L370.323 526.057ZM451.677 483.134L389.677 526.057L388.538 524.413L450.538 481.489L451.677 483.134ZM459 409.923V469.157H457V409.923H459ZM389.677 353.023L451.677 395.946L450.538 397.59L388.538 354.667L389.677 353.023ZM457 409.923C457 405.001 454.585 400.392 450.538 397.59L451.677 395.946C456.263 399.121 459 404.345 459 409.923H457ZM450.538 481.489C454.585 478.688 457 474.079 457 469.157H459C459 474.735 456.263 479.959 451.677 483.134L450.538 481.489ZM371.462 524.413C376.599 527.969 383.401 527.969 388.538 524.413L389.677 526.057C383.855 530.087 376.145 530.087 370.323 526.057L371.462 524.413ZM303 469.157C303 474.079 305.415 478.688 309.462 481.489L308.323 483.134C303.737 479.959 301 474.735 301 469.157H303ZM370.323 353.023C376.145 348.992 383.855 348.992 389.677 353.023L388.538 354.667C383.401 351.111 376.599 351.111 371.462 354.667L370.323 353.023ZM309.462 397.59C305.415 400.392 303 405.001 303 409.923H301C301 404.345 303.737 399.121 308.323 395.946L309.462 397.59Z",
    fill: "#2E2F33",
    mask: "url(#path-7-inside-2_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter4_i_791_28467)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.107 353.845C185.628 350.052 178.372 350.052 172.893 353.845L110.893 396.768C106.576 399.757 104 404.673 104 409.923V469.157C104 474.407 106.576 479.323 110.893 482.312L172.893 525.235C178.372 529.028 185.628 529.028 191.107 525.235L253.107 482.312C257.424 479.323 260 474.407 260 469.157V409.923C260 404.673 257.424 399.757 253.107 396.768L191.107 353.845Z",
    fill: "url(#paint1_linear_791_28467)",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 248,
    width: 176,
    height: 64,
    rx: 12,
    fill: "#18181B"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 198.5,
    y: 252.5,
    width: 167,
    height: 55,
    rx: 7.5,
    fill: "url(#paint2_linear_791_28467)",
    stroke: "url(#paint3_linear_791_28467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 252L216 308",
    stroke: "#303134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 252L238 308",
    stroke: "#303134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 252L260 308",
    stroke: "#303134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 252L282 308",
    stroke: "#303134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 252L304 308",
    stroke: "#303134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 238L326 322",
    stroke: "#303134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 243.5L348 316.5",
    stroke: "#303134"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 230,
    width: 16,
    height: 100,
    rx: 4,
    fill: "url(#paint4_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 258,
    width: 16,
    height: 44,
    rx: 4,
    fill: "url(#paint5_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 243,
    width: 16,
    height: 74,
    rx: 4,
    fill: "url(#paint6_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 272,
    width: 4,
    height: 16,
    rx: 2,
    fill: "url(#paint7_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388,
    y: 272,
    width: 4,
    height: 16,
    rx: 2,
    fill: "url(#paint8_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter11_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 275,
    width: 4,
    height: 10,
    rx: 2,
    fill: "url(#paint9_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter12_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 275,
    width: 4,
    height: 10,
    rx: 2,
    fill: "url(#paint10_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 16,
    rx: 2,
    transform: "matrix(-1 0 0 1 174 272)",
    fill: "url(#paint11_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 16,
    rx: 2,
    transform: "matrix(-1 0 0 1 166 272)",
    fill: "url(#paint12_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter15_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 10,
    rx: 2,
    transform: "matrix(-1 0 0 1 158 275)",
    fill: "url(#paint13_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter16_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 10,
    rx: 2,
    transform: "matrix(-1 0 0 1 150 275)",
    fill: "url(#paint14_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 272,
    width: 16,
    height: 16,
    rx: 4,
    fill: "url(#paint15_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 270,
    width: 16,
    height: 20,
    rx: 4,
    fill: "url(#paint16_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 264,
    width: 16,
    height: 32,
    rx: 4,
    fill: "url(#paint17_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 264,
    width: 16,
    height: 32,
    rx: 4,
    fill: "url(#paint18_linear_791_28467)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 354,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint19_linear_791_28467)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.5,
    y: 352.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#333438",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.54 370.592C271.721 375.424 274.231 380.882 279.125 382.639C279.313 382.765 279.501 383.016 279.501 383.204V384.082C279.501 384.208 279.501 384.271 279.438 384.333C279.376 384.584 279.125 384.71 278.874 384.584C275.36 383.455 272.662 380.757 271.533 377.243C269.65 371.282 272.913 364.945 278.874 363.063C278.937 363 279.062 363 279.125 363C279.376 363.063 279.501 363.251 279.501 363.502V364.38C279.501 364.694 279.376 364.882 279.125 365.008C276.552 365.949 274.482 367.957 273.54 370.592ZM285.211 363.314C285.274 363.063 285.525 362.937 285.776 363.063C289.227 364.192 291.988 366.89 293.117 370.467C294.999 376.427 291.737 382.765 285.776 384.647C285.713 384.71 285.588 384.71 285.525 384.71C285.274 384.647 285.148 384.459 285.148 384.208V383.329C285.148 383.016 285.274 382.827 285.525 382.702C288.097 381.761 290.168 379.753 291.109 377.118C292.929 372.286 290.419 366.827 285.525 365.071C285.337 364.945 285.148 364.694 285.148 364.443V363.565C285.148 363.439 285.148 363.376 285.211 363.314ZM282.512 372.788C285.147 373.102 286.465 373.855 286.465 376.051C286.465 377.745 285.21 379.063 283.328 379.377V380.882C283.265 381.196 283.077 381.384 282.826 381.384H281.884C281.571 381.322 281.383 381.133 281.383 380.882V379.377C279.312 379.063 278.308 377.933 278.057 376.365V376.302C278.057 376.051 278.245 375.863 278.496 375.863H279.563C279.751 375.863 279.939 375.988 280.002 376.239C280.19 377.18 280.755 377.871 282.386 377.871C283.579 377.871 284.457 377.181 284.457 376.177C284.457 375.173 283.892 374.796 282.135 374.482C279.5 374.169 278.245 373.353 278.245 371.282C278.245 369.714 279.437 368.459 281.32 368.208V366.765C281.383 366.451 281.571 366.263 281.822 366.263H282.763C283.077 366.325 283.265 366.514 283.265 366.765V368.271C284.708 368.396 285.837 369.463 286.088 370.843V370.906C286.088 371.157 285.9 371.345 285.649 371.345H284.645C284.457 371.345 284.269 371.22 284.206 371.031C283.892 370.09 283.265 369.714 282.135 369.714C280.881 369.714 280.253 370.278 280.253 371.157C280.253 372.035 280.63 372.537 282.512 372.788Z",
    fill: "white",
    fillOpacity: 0.74
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_i_791_28467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 166,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint20_linear_791_28467)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.5,
    y: 164.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#333438",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.598 186.666C283.488 186.675 282.922 186.713 281.66 186.713C280.656 186.713 279.944 186.679 279.694 186.666C275.814 186.475 272.918 185.721 272.918 184.817C272.918 183.913 275.814 183.159 279.694 182.966V185.914C279.947 185.935 280.674 185.983 281.678 185.983C282.882 185.983 283.485 185.927 283.594 185.915V182.968C287.465 183.16 290.355 183.915 290.355 184.817C290.355 185.719 287.466 186.473 283.594 186.665L283.598 186.666ZM283.598 182.663V180.024H289.001V176H274.291V180.024H279.693V182.662C275.302 182.887 272 183.859 272 185.024C272 186.189 275.302 187.16 279.693 187.386V195.842H283.597V187.383C287.977 187.158 291.274 186.187 291.274 185.023C291.274 183.859 287.98 182.888 283.597 182.662L283.598 182.663Z",
    fill: "white",
    fillOpacity: 0.74
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260 248V229.863C260 227.511 261.375 225.375 263.517 224.401L278.483 217.599C280.625 216.625 282 214.489 282 212.137V209",
    stroke: "#303134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 230V209",
    stroke: "#303134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 206V209",
    stroke: "#78797F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 248V229.863C304 227.511 302.625 225.375 300.483 224.401L285.517 217.599C283.375 216.625 282 214.489 282 212.137V209",
    stroke: "url(#paint21_linear_791_28467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 312V330.137C304 332.489 302.625 334.625 300.483 335.599L285.517 342.401C283.375 343.375 282 345.511 282 347.863V351",
    stroke: "#303134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 330V351",
    stroke: "#303134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 354V351",
    stroke: "#78797F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 312V330.137C260 332.489 261.375 334.625 263.517 335.599L278.483 342.401C280.625 343.375 282 345.511 282 347.863V351",
    stroke: "url(#paint22_linear_791_28467)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64,
    filter: "url(#filter23_f_791_28467)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 119,
    r: 119,
    fill: "#A855F7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_791_28467",
    x: 122,
    y: 120,
    width: 320,
    height: 320,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_791_28467"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.221844 0 0 0 0 0.225529 0 0 0 0 0.240267 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_791_28467",
    x: 104,
    y: 32,
    width: 157,
    height: 178.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_791_28467",
    x: 302,
    y: 32,
    width: 157,
    height: 178.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_791_28467",
    x: 302,
    y: 351,
    width: 157,
    height: 178.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_791_28467",
    x: 104,
    y: 351,
    width: 157,
    height: 178.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_791_28467",
    x: 146,
    y: 212,
    width: 272,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_791_28467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_791_28467",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_791_28467",
    x: 274,
    y: 230,
    width: 17,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_791_28467",
    x: 252,
    y: 258,
    width: 17,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_791_28467",
    x: 318,
    y: 243,
    width: 17,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_791_28467",
    x: 380,
    y: 272,
    width: 5,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_791_28467",
    x: 388,
    y: 272,
    width: 5,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_791_28467",
    x: 396,
    y: 275,
    width: 5,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_791_28467",
    x: 404,
    y: 275,
    width: 5,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_791_28467",
    x: 170,
    y: 272,
    width: 5,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_791_28467",
    x: 162,
    y: 272,
    width: 5,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_791_28467",
    x: 154,
    y: 275,
    width: 5,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_791_28467",
    x: 146,
    y: 275,
    width: 5,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_791_28467",
    x: 230,
    y: 272,
    width: 17,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_791_28467",
    x: 296,
    y: 270,
    width: 17,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_791_28467",
    x: 208,
    y: 264,
    width: 17,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_791_28467",
    x: 340,
    y: 264,
    width: 17,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_791_28467",
    x: 259,
    y: 351,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_i_791_28467",
    x: 259,
    y: 163,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_791_28467",
    x: -200,
    y: -200,
    width: 638,
    height: 638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_791_28467"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_791_28467",
    x1: 380,
    y1: 32,
    x2: 380,
    y2: 209.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_791_28467",
    x1: 182,
    y1: 351,
    x2: 182,
    y2: 528.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_791_28467",
    x1: 366,
    y1: 252,
    x2: 198,
    y2: 308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26272B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_791_28467",
    x1: 282,
    y1: 252,
    x2: 282,
    y2: 308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_791_28467",
    x1: 282,
    y1: 230,
    x2: 282,
    y2: 330,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_791_28467",
    x1: 260,
    y1: 258,
    x2: 260,
    y2: 302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_791_28467",
    x1: 326,
    y1: 243,
    x2: 326,
    y2: 317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_791_28467",
    x1: 382,
    y1: 272,
    x2: 382,
    y2: 288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_791_28467",
    x1: 390,
    y1: 272,
    x2: 390,
    y2: 288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_791_28467",
    x1: 398,
    y1: 275,
    x2: 398,
    y2: 285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_791_28467",
    x1: 406,
    y1: 275,
    x2: 406,
    y2: 285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_791_28467",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_791_28467",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_791_28467",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_791_28467",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_791_28467",
    x1: 238,
    y1: 272,
    x2: 238,
    y2: 288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_791_28467",
    x1: 304,
    y1: 270,
    x2: 304,
    y2: 290,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37373E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_791_28467",
    x1: 216,
    y1: 264,
    x2: 216,
    y2: 296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_791_28467",
    x1: 348,
    y1: 264,
    x2: 348,
    y2: 296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37373E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_791_28467",
    x1: 282,
    y1: 354,
    x2: 282,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_791_28467",
    x1: 282,
    y1: 166,
    x2: 282,
    y2: 206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_791_28467",
    x1: 293,
    y1: 209,
    x2: 293,
    y2: 248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_791_28467",
    x1: 271,
    y1: 351,
    x2: 271,
    y2: 312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303134"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_28467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 564,
    height: 560,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_791_28467"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 120,
    width: 320,
    height: 320,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock1);
export default __webpack_public_path__ + "static/media/block1.980777913ace446bce1578b41d6ba511.svg";
export { ForwardRef as ReactComponent };